
import { RevCard } from '@ds/components/Card'
import { RevSkeleton } from '@ds/components/Skeleton'

import translations from './Card.translations'

export default {
  components: {
    RevCard,
    RevSkeleton,
  },
  computed: {
    translations: () => translations,
  },
}
